import { IIcon } from '@rbilabs/components-library';

import { TLocalizationKey } from 'types/i18n';

export type UnavailabilityReasonObject = {
  errorModalTitle: string;
  errorModalSubTitle: string;
  errorModalBody: string;
  errorModalFeedback: string;
  errorModalIcon?: keyof IIcon;
};

type UnavailabilityReasonMapItems = {
  subtitle: TLocalizationKey;
  body: TLocalizationKey;
  feedBackMessage: TLocalizationKey;
  icon?: keyof IIcon;
};

type UnavailabilityReasonMap = Record<string, UnavailabilityReasonMapItems>;

export enum UnavailabilityReason {
  NUMBER_OF_ORDERS = 'NUMBER_OF_ORDERS',
  TECHNICAL_ISSUES = 'TECHNICAL_ISSUES',
  RESTAURANT_NEAR_TO_CLOSE = 'RESTAURANT_NEAR_TO_CLOSE',
  WEATHER = 'WEATHER',
  UNREACHABLE_RESTAURANT = 'UNREACHABLE_RESTAURANT',
  NO_DRIVERS_AVAILABLE = 'NO_DRIVERS_AVAILABLE',
  REDUCED_CAPACITY = 'REDUCED_CAPACITY',
  OUTSIDE_DELIVERY_AREA = 'OUTSIDE_DELIVERY_AREA',
  STORE_NOT_FOUND_OR_CONFIGURED = 'STORE_NOT_FOUND_OR_CONFIGURED',
}

export const unavailabilityReasonMap: UnavailabilityReasonMap = {
  NUMBER_OF_ORDERS: {
    subtitle: 'unavailabilityReasonNumberOfOrdersSubtitle',
    body: 'unavailabilityReasonNumberOfOrdersBody',
    feedBackMessage: 'unavailabilityReasonPausedFeedback',
    icon: 'people',
  },
  TECHNICAL_ISSUES: {
    subtitle: 'unavailabilityReasonTechnicalIssuesSubtitle',
    body: 'unavailabilityReasonTechnicalIssuesBody',
    feedBackMessage: 'unavailabilityReasonPausedMinutesFeedback',
    icon: 'warning',
  },
  RESTAURANT_NEAR_TO_CLOSE: {
    subtitle: 'unavailabilityReasonRestaurantNearToCloseSubtitle',
    body: 'unavailabilityReasonRestaurantNearToCloseBody',
    feedBackMessage: 'unavailabilityReasonPausedFeedback',
  },
  WEATHER: {
    subtitle: 'unavailabilityReasonWeatherSubtitle',
    body: 'unavailabilityReasonWeatherBody',
    feedBackMessage: 'unavailabilityReasonPausedMinutesFeedback',
    icon: 'thunderstorm',
  },
  UNREACHABLE_RESTAURANT: {
    subtitle: 'unavailabilityReasonUnreachableRestaurantSubtitle',
    body: 'unavailabilityReasonUnreachableRestaurantBody',
    feedBackMessage: 'unavailabilityReasonPausedMinutesFeedback',
    icon: 'traffic',
  },
  NO_DRIVERS_AVAILABLE: {
    subtitle: 'unavailabilityReasonNoDriversAvailableSubtitle',
    body: 'unavailabilityReasonNoDriversAvailableBody',
    feedBackMessage: 'unavailabilityReasonPausedFeedback',
    icon: 'motorcycleHelmet',
  },
  REDUCED_CAPACITY: {
    subtitle: 'unavailabilityReasonReducedCapacitySubtitle',
    body: 'unavailabilityReasonReducedCapacityBody',
    feedBackMessage: 'unavailabilityReasonPausedFeedback',
    icon: 'locationOff',
  },
  STORE_NOT_FOUND_OR_CONFIGURED: {
    subtitle: 'unavailabilityReasonStoreNotFoundOrConfiguredSubtitle',
    body: 'unavailabilityReasonStoreNotFoundOrConfiguredBody',
    feedBackMessage: 'unavailabilityReasonPausedMinutesFeedback',
    icon: 'warning',
  },
  OUTSIDE_DELIVERY_AREA: {
    subtitle: 'unavailabilityReasonOutsideDeliveryAreaSubtitle',
    body: 'unavailabilityReasonOutsideDeliveryAreaBody',
    feedBackMessage: 'unavailabilityReasonPausedMinutesFeedback',
    icon: 'warning',
  },
};
